export default __webpack_public_path__ + "static/media/2_template.25265550.svg";